import MimeType from "./MimeType";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

const WILDCARD: string = '*';

export default class MimeTypeFilter {
	private _whitelist: Array<MimeType>;
	private _blacklist: Array<MimeType>;

	constructor(blacklist: Array<MimeType>, whitelist?: Array<MimeType>) {
		this._whitelist = FunctionHelper.applyValue(whitelist, []);
		this._blacklist = blacklist;
	}

	public static check(mimeType: MimeType, whitelist?: Array<MimeType>, blacklist?: Array<MimeType>) {
		if (FunctionHelper.exists(whitelist) && whitelist!.length > 0) {
			if (!this.filter(mimeType, whitelist!)) {
				return false;
			}
		}

		return !this.filter(mimeType, FunctionHelper.applyValue(blacklist, []));
	}


	public check(mimeType: MimeType): boolean {
		return MimeTypeFilter.check(mimeType, this.whitelist, this.blacklist);
	}

	public static checkSelection(selection: Array<MimeType>, whitelist?: Array<MimeType>, blacklist?: Array<MimeType>) {
		for (let mimeType of selection) {
			if (!this.check(mimeType, whitelist, blacklist)) {
				return false
			}
		}

		return true;
	}

	public checkSelection(selection: Array<MimeType>): boolean {
		return MimeTypeFilter.checkSelection(selection, this.whitelist, this.blacklist);
	}

	private static filter(mimeType: MimeType, list: Array<MimeType>): boolean {
		for (let entry of list) {
			if (entry.fileTypeId !== 0 && entry.fileTypeId === mimeType.fileTypeId) {
				return true;
			}

			if (entry.type === WILDCARD && entry.subtype === WILDCARD) {
				return true;
			}

			if (entry.type === WILDCARD && entry.subtype === mimeType.subtype) {
				return true;
			}

			if (entry.subtype === WILDCARD && entry.type === mimeType.type) {
				return true;
			}

			if (entry.toString() === mimeType.toString()) {
				return true;
			}
		}

		return false;
	}

	get whitelist(): Array<MimeType> {
		return this._whitelist;
	}

	get blacklist(): Array<MimeType> {
		return this._blacklist;
	}
}